<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Campaña</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-12 card-wrapper">
          <div class="card mb-4">
            <!-- Card header -->
            <div class="card-header">
              <h3 class="mb-0">
                <span>{{ title }}</span>
              </h3>
            </div>
            <!-- Card body -->
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 text-left">
                  <campaign-info v-if="isDataLoaded" :campaign="campaign" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isDataLoaded" class="container-fluid">
      <div v-if="isDataLoaded" class="row">
        <div class="col-md-6 col-sm-12">
          <campaign-date-form
            ref="dateForm"
            :title="formTitle"
            :campaign="campaign"
            :server-errors="serverErrors"
            @save="save"
            @cancel="reset"
          />
        </div>
        <div class="col-md-6 col-sm-12">
          <campaign-dates-list :dates="campaign.dates" :campaign-id="campaign.id" @dateDeleted="dateDeleted" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignInfo from './Show/CampaignInfo';
import CampaignDateForm from './Forms/CampaignDateForm';
import CampaignDatesList from './List/CampaignDatesList';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CampaignDatesBus from '../../events/buses/campaign-dates.event';
import moment from 'moment';

export default {
  name: 'CampaignsDates',
  components: {
    CampaignInfo,
    CampaignDateForm,
    CampaignDatesList,
    RouteBreadCrumb,
  },

  props: {
    title: {
      type: String,
      default: 'Datos Campaña',
    },
  },

  data() {
    return {
      isDataLoaded: false,
      campaign: null,
      editDate: null,
      serverErrors: [],
    };
  },

  computed: {
    formTitle() {
      if (this.editDate) {
        let dateString = moment(this.editDate.date).format('DD/MM/YYYY');
        let detail = this.editDate.detail ? `- ${this.editDate.detail}` : '';
        return `Editar: ${dateString} ${detail}`;
      }
      return 'Agregar nueva fecha límite';
    },
  },

  created() {
    CampaignDatesBus.$on('campaign-dates-on-edit', this.setEditDate);
  },

  beforeDestroy() {
    CampaignDatesBus.$off('campaign-dates-on-edit', this.setEditDate);
  },

  mounted() {
    this.fetchCampaign(this.$route.params.id);
  },

  methods: {
    fetchCampaign(campaignId) {
      const params = {
        include: ['crops', 'dates'],
        sort: 'date',
      };
      this.$services
        .resource('campaigns')
        .show(campaignId, params)
        .then((res) => res.data.data)
        .then((campaign) => {
          this.campaign = campaign;
          this.sortDateList();
          this.isDataLoaded = true;
        });
    },

    setEditDate(date) {
      this.editDate = date;
    },

    save(date) {
      if (this.editDate) {
        this.update(this.editDate.id, date);
      } else {
        this.create(date);
      }
    },

    reset() {
      this.serverErrors = [];
      this.editDate = null;
      this.$refs.dateForm.reset();
    },

    create(date) {
      this.serverErrors = [];
      this.$services
        .resource('campaign_dates')
        .create(date)
        .then((res) => {
          this.addDate(res.data.data);
          this.reset();
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },

    update(id, date) {
      this.serverErrors = [];
      this.$services
        .resource('campaign_dates')
        .update(id, date)
        .then((res) => {
          this.updateList(res.data.data);
          this.reset();
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },

    addDate(date) {
      this.campaign.dates.push(date);
      this.$success('La fecha fue agregada con éxito', 'Nueva Fecha!');
      this.sortDateList();
    },

    updateList(date) {
      for (let i = 0; i < this.campaign.dates.length; i++) {
        if (date.id === this.campaign.dates[i].id) {
          this.campaign.dates[i].date = date.date;
          this.campaign.dates[i].detail = date.detail;
          break;
        }
      }
      this.$success('La fecha fue editada con éxito', 'Fecha Editada!');
      this.sortDateList();
    },

    dateDeleted(id) {
      this.campaign.dates = this.campaign.dates.filter((e) => e.id !== id);
    },

    sortDateList() {
      this.campaign.dates.sort(this.compare_date);
    },

    compare_date(a, b) {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
    },
  },
};
</script>
